import moment from "moment";

const initialState = {
  status: "invalid",
  filters: {
    histogram_kinds: [],
    histogram_range_from: moment().subtract(1, "month"),
    histogram_range_to: moment(),
    histogram_user_names: [],
    histogram_interval: "day",
    histogram_date_option: "last_30_days",
  },
  data: {},
};
export default (state = initialState, action) => {
  switch (action.type) {
    case "USER_ERRORS_STATS_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "USER_ERRORS_STATS_UPDATING":
      return {
        ...state,
        status: "updating",
      };
    case "USER_ERRORS_STATS_SUCCESS":
      return {
        ...state,
        status: "success",
        data: action.data,
      };
    case "USER_ERRORS_STATS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    case "USER_ERRORS_STATS_SET_FILTER": {
      return {
        ...state,
        filters: { ...state.filters, ...action.filter },
      };
    }
    default:
      return state;
  }
};
